'use strict';
const angular = require('angular');
const {/*copy, equals, */isArray, isFunction, isObject, isString, isUndefined, noop} = angular;
const debounce = require('lodash/debounce');

import {CachedDataSnapshot} from './CachedDataSnapshot';

// Incorrect name. Really Firebase Collection Factory
export function FirebaseObjectFactoryProvider() {
  let hashId = 0;
  return {
    /*TODO: implement some form of caching strategy
     *
     * Use persistent cache to cache each unique path in firebase using LRU on th caches themselves to delete older locations.
     *
     * Updating Cache
     * Upon receiving values from Firebase, update the corresponding key in the cache
     *
     * Initializing Cache
     * UNFILTERED HANDLING
     * Initialize cache_pending_updates to track the KEYS added from the cache.
     * For each key in the cache, apply it as a child added event as normal.
     * On child added events, check if the key being added/updated is in the cache_pending_updates list.
     *  If yes, remove it from cache_pending_updates and (if needed?) fire a child_changed event
     * On initial value event, compare the keys in he object to the keys in the DataSnapshot and purge any keys in the cache that are not in the snapshot.
     *
     *
     * FILTERED HANDLING
     * Upon requesting a filtered key, check the cache and use it if available.
     *
     */


    //TODO: define $refresh method for manual requests to update in bindOnce mode
    //TODO: define $bindToEvent method and support
    //TODO: define $unbindFromEvent method
    //TODO: return an array of ids if you pass an array of initial filters

    //TODO: handle security errors gracefully. Need to report error and log the access attempt.
    //TODO: Need hook to notify observer that the error occurred so that unauthorized keys can be removed from filters automatically, configurably.

    //TODO: complete initial support for filtered<->unfiltered transition
    $get: [
      '$window',
      '$rootScope',
      '$exceptionHandler',
      '$q',
      '$timeout',
      '$persistentCacheFactory',
      '$firebase',
      'FirebaseUtil',
      'ObservableArrayFactory',
      '$$FirebaseListener',
      '$$FirebaseObjectListener',
      '$$ObservableArrayListener',
      function (
        $window,
        $rootScope,
        $exceptionHandler,
        $q,
        $timeout,
        $persistentCacheFactory,
        $firebase,
        FirebaseUtil,
        ObservableArrayFactory,
        FirebaseListener,
        FirebaseObjectListener,
        ObservableArrayListener,
      ) {
        /**
         * requires path
         * accepts constructor, filters,
         * @param {string|Window.Firebase|Object} config
         * @constructor
         */
        function FirebaseObject(config) {
          var deferred = $q.defer();
          config = validatedConstructorArgs.call(this, config);

          // TODO(security): The factory method lazy evaluation is conceivably exploitable at run time. investigate
          Object.defineProperties(this, {
            $constructor: {
              value: config.$constructor || null
            },
            $factory: {
              value: {
                factory: config.factory || null,
                methodName: config.factoryMethodName || null
              }
            },
            $bindOnce: {
              writable: true,
              value: !!config.bindOnce
            },
            $$root: {
              value: config.path ? FirebaseUtil.firebaseRef(config.path) : config.ref
            },
            $$externalListeners: {value: []},
            $$listeners: {
              value: {child_added: [], child_changed: [], child_removed: [], value: []}
            },
            $$loadStatusAnalyzer: {
              value: {deferred: deferred, isLoaded: false, promise: $q.any([deferred.promise, $timeout(noop, 2500)])}
            },
            $$filteredMode: {
              get: function () {
                return !!this.$$filters.length;
              }.bind(this)
            },
            $$filters: {
              value: new ObservableArrayFactory()
            },
            $$size: {
              writable: true,
              value: 0
            },
            $$retryTimeouts: {
              writable: true,
              value: {}
            }
          });

          // initialize cache
          var cachePath = this.$$root && this.$$root.toString();
          Object.defineProperty(this, '$$cache', {
            configurable: true,
            value: $persistentCacheFactory.get(cachePath) || $persistentCacheFactory(cachePath, {capacity: 25000})
          });

          // initialize filter management
          this.$$filters.addListener('element_added', filterAdded, this);
          this.$$filters.addListener('element_removed', filterRemoved, this);
          this.$$filters.addListener('element_updated', filterChanged, this);

          // initialize firebase listeners by initial filtering mode
          if (config.filters && config.filters.length) {
            // establish a debounce on filtered data $loaded resolver.
            /* TODO Convert load analysis to wait for the loaded status of any/all filters, and then for all child added events from those filters
             *      Continue to debounce the load analyzer so it only performs a check shortly after no children have been added.
             */
            this.$$loadStatusAnalyzer.complete = debounce(_onValueLoadAnalyzerSuccess.bind(this), 150);

            //TODO: setup filter listeners so that if a filter is removed, the object is reset to use not use instead.
            for (var filter in config.filters) {
              if (config.filters.hasOwnProperty(filter)) {
                FirebaseObject.prototype.$addFilter.call(this, config.filters[filter]);
              }
            }
          } else {

            // TODO: pagination initialization injection point.
            // Add a config flag for optional pagination.
            // If paginate: initPaginated.call(this);
            // else: initUnfiltered.call(this);
            // Pagination can then implement .next() and .hasNext() which will need to be added to the prototype.
            // Pagination will need to track pages and provide configuration to optionally bind once or bind on events to allow for flexible use

            initUnfiltered.call(this);

            //TODO: setup filter listeners so that if a filter is added, the object is reset to use filters instead.
          }
          //console.log('new FirebaseObject\n', this);

          // TODO: if there is data in the cache and we are unfiltered, load that data and init cleanup handling
        }

        //************************************************************************************************************
        // Prototype
        //************************************************************************************************************

        FirebaseObject.prototype.$ref = $ref;
        FirebaseObject.prototype.$loaded = $loaded;
        FirebaseObject.prototype.$on = $on;
        FirebaseObject.prototype.$off = $off;
        FirebaseObject.prototype.$size = $size;
        //Resume needs to update to the correct state. Current approach is naive.
        //FirebaseObject.prototype.$pause = $pause;
        //FirebaseObject.prototype.$resume = $resume;
        FirebaseObject.prototype.$addFilter = $addFilter;
        FirebaseObject.prototype.$removeFilter = $removeFilter;
        FirebaseObject.prototype.$bindToScope = $bindToScope;
        FirebaseObject.prototype.$destroy = $destroy;

        function $ref() {
          return this.$$root;
        }

        /**
         *
         * @returns {Promise}
         */
        function $loaded() {
          return this.$$loadStatusAnalyzer.promise;
        }

        function $size() {
          return this.$$size;
        }

        /**
         * Subscribe to the specified event name on the current FirebaseObject.
         *
         * child_added params: newValue, key
         * child_changed params: newValue, oldValue, key
         * child_removed params: oldValue, key
         * value params: firebaseObject, newValue, oldValue, key
         *
         * @param event
         * @param callback
         * @param context
         * @returns {*}
         */
        function $on(event, callback, context) {
          __validateEventType(event, '$on');
          if (isUndefined(context)) context = null;
          _fireOnSubEvents.call(this, event, callback, context);
          this.$$listeners[event].push({callback: callback, context: context});
          return callback;
        }

        function _fireOnSubEvents(event, callback, context) {
          if (event === 'value') {
            callback.call(context, this);
          } else if (event === 'child_added') {
            for (var key in this) {
              if (this.hasOwnProperty(key)) {
                callback.call(context, this[key], key);
              }
            }
          }
        }

        function $off(event, callback) {
          __validateEventType(event, '$off');
          if (isUndefined(callback)) {
            while (this.$$listeners[event].length > 0) {
              this.$$listeners[event].pop();
            }
          } else {
            for (var i = 0, length = this.$$listeners[event].length; i < length; i++) {
              if (this.$$listeners[event][i] === callback) {
                this.$$listeners[event].splice(i, 1);
                i--;
              }
            }
          }
        }

        function $pause() {
          var i = this.$$externalListeners.length;
          var listener;

          while (i--) {
            listener = this.$$externalListeners[i];
            if (listener.isAlive() && listener.isActive()) {
              listener.pause();
            }
          }
        }

        function $resume() {
          var i = this.$$externalListeners.length;
          var listener;

          while (i--) {
            listener = this.$$externalListeners[i];
            if (listener.isAlive() && !listener.isActive()) {
              listener.resume();
            }
          }
        }

        /**
         *
         * @param {Object} filter can be one of, an array, a firebase object, or an ObservableArray
         */
        function $addFilter(filter) {
          var validatedFilter = validateFilter.call(this, filter);

          this.$$filters.push(validatedFilter);
          return validatedFilter.id;
        }

        function $removeFilter(filterId) {
          var filterIndex = this.$$filters.indexOf(filterId);
          if (filterIndex > -1) {
            this.$$filters.splice(filterIndex, 1);
          }
        }

        function $bindToScope(scope, bindConfig) {
          var self = this;
          var listeners = [];
          // TODO: consider refactoring cases into separate init methods
          // TODO: Refactor assignment of changes to support methods.
          if (!(scope && isFunction(scope.$on) && isFunction(scope.$evalAsync))) {
            throw new Error('You must pass a scope to bind to!');
          } else {
            var property = bindConfig && isString(bindConfig.property) ? bindConfig.property : isString(bindConfig) && bindConfig;
            var options = isObject(bindConfig) ? bindConfig : {};
            var arrayMode = !!options.asArray;
            var vm = isString(options.controllerAs) ? scope[options.controllerAs] : scope;

            if (!property) {
              throw new Error('You must pass a config object with property: <scope property name>!');
            } else {
              if (!arrayMode) {
                vm[property] = self;
              } else {
                vm[property] = [];

                // bind to param mode
                listeners.push(
                  new FirebaseObjectListener(self, 'child_added', arrayChildAdded, self),
                  new FirebaseObjectListener(self, 'child_removed', arrayChildRemoved, self)
                );

                if (!self.$bindOnce) listeners.push(new FirebaseObjectListener(self, 'child_changed', arrayChildChanged, self));
              }

              // trigger change so that $digest will update the DOM
              listeners.push(new FirebaseObjectListener(self, 'value', scope.$safeApply.bind(scope, scopeBindingSpy/*noop*/), self));
              if (options.loaded) self.$loaded().then(scopeBindingSpy/*noop*/);

              var binding = new Binding(vm, property, listeners);

              scope.$on('$destroy', binding.destroy.bind(binding));

              return binding;
            }
          }

          function scopeBindingSpy() {
            //console.debug(self.$$root.toString() + ' FBO.value triggering digest; size: ' + self.$size() + '; value: ', self);
          }

          function arrayChildAdded(newValue, key) {
            scope.$evalAsync(function () {
              scope[property].push(wrapPrimitive(newValue, key));
            });
          }

          function arrayChildChanged(newValue, oldValue, key) {
            var wrapped = wrapPrimitive(newValue, key);
            if (wrapped === self[key]) return;

            scope.$evalAsync(function () {
              var array = scope[property];
              if (!isArray(array)) return;
              var i = array.length;

              while (i--) {
                if (array[i].$id === key) {
                  array[i] = wrapPrimitive(self[key], key);
                  return;
                }
              }
            });
          }

          function arrayChildRemoved(oldValue, key) {
            scope.$evalAsync(function () {
              var array = scope[property];
              if (!isArray(array)) return;
              var i = array.length;

              while (i--) {
                if (array[i].$id === key) {
                  array.splice(i, 1);
                  return;
                }
              }
            });
          }

          function wrapPrimitive(value, key) {
            return isObject(value) ?
              value :
              {$id: key, $value: value};
          }
        }

        function $destroy() {
          __destroyListeners.call(this);

          if (this.$$filteredMode) {
            this.$$filters.removeListeners();  // do not respond to further changes
            this.$$filters.empty();            // then empty the list
          }

          var i = this.$$externalListeners.length;
          var listener;

          while (i--) {
            listener = this.$$externalListeners.pop();
            if (listener.isAlive()) {
              listener.destroy();
            }
          }

          i = this.$$listeners.length;

          while (i--) {
            listener = this.$$listeners.pop();
            if (listener.destroy && listener.isAlive && listener.isAlive()) {
              listener.destroy();
            }
          }

          for (var filterKey in this.$$retryTimeouts) {
            if (this.$$retryTimeouts.hasOwnProperty(filterKey)) {
              clearTimeout(this.$$retryTimeouts[filterKey]);
              delete this.$$retryTimeouts[filterKey];
            }
          }
        }


        //************************************************************************************************************
        // Initialization
        //************************************************************************************************************

        // converted to rely on value events instead of child_added events
        //
        function initUnfiltered() {
          this.$$externalListeners.push(
            new FirebaseListener(this.$$root, 'value', updateValue, __onCancelCallback, this, {start: true}),
            new FirebaseListener(this.$$root, 'child_changed', changeChild, __onCancelCallback, this, {start: true})
          );

          // Retrieve each key in the cache and add it to the FBO
          var cacheData = this.$$cache.getAll();

          updateValue.call(this, new CachedDataSnapshot(null, cacheData, this.$$root));
        }

        function __onCancelCallback(error) {
          if (!this.$$loadStatusAnalyzer.isLoaded) {
            this.$$loadStatusAnalyzer.deferred.reject(error);
          }
          $exceptionHandler(error, "FirebaseObject Listener Cancelled");
        }

        function __destroyListeners() {
          __destroyListenersByEventType.call(this, 'child_added');
          __destroyListenersByEventType.call(this, 'child_changed');
          __destroyListenersByEventType.call(this, 'child_removed');
          __destroyListenersByEventType.call(this, 'value');
        }

        function __destroyListenersByEventType(event) {
          var i = this.$$listeners[event].length;
          var listener;

          while (i--) {
            listener = this.$$listeners[event].pop();
          }
        }

        function destroyFirebaseListenerById(id) {
          var i = this.$$externalListeners.length;
          var listener;

          while (i--) {
            listener = this.$$externalListeners[i];
            if (listener.id === id && listener.isAlive()) {
              listener.destroy();
              this.$$externalListeners.slice(i, 1);
            }
          }
        }


        //************************************************************************************************************
        // Notifiers
        //************************************************************************************************************

        function notifyChildAdded() {
          for (var i = 0, length = this.$$listeners.child_added.length; i < length; i++) {
            this.$$listeners.child_added[i].callback.apply(this.$$listeners.child_added[i].context, arguments);
          }
        }

        function notifyChildChanged() {
          //console.debug(this.$$root.toString() + ' child event; size: ' + this.$size() + '; keys: ' + Object.keys(this).length);
          for (var i = 0, length = this.$$listeners.child_changed.length; i < length; i++) {
            this.$$listeners.child_changed[i].callback.apply(this.$$listeners.child_changed[i].context, arguments);
          }
        }

        function notifyChildRemoved() {
          for (var i = 0, length = this.$$listeners.child_removed.length; i < length; i++) {
            this.$$listeners.child_removed[i].callback.apply(this.$$listeners.child_removed[i].context, arguments);
          }
        }

        function notifyValueChanged() {
          //console.debug(this.$$root.toString() + ' value event; size: ' + this.$size() + '; keys: ' + Object.keys(this).length);
          for (var i = 0, length = this.$$listeners.value.length; i < length; i++) {
            this.$$listeners.value[i].callback.apply(this.$$listeners.value[i].context, arguments);
          }
        }


        //************************************************************************************************************
        // Update properties of this object
        //************************************************************************************************************

        function updateValue(ss, listener) {
          var self = this;
          var removed = 0;
          var added = 0;

          for (var key in this) {
            if (this.hasOwnProperty(key) && !ss.hasChild(key)) {
              removeChild.call(this, ss.child(key), null);
              removed++;
            }
          }

          ss.forEach(function (child) {
            var key = child.key();
            if (!self.hasOwnProperty(key)) {
              self.$$cache.put(key, child.val());
              self[key] = constructChild.call(self, child, null);
              self.$$size++;
              notifyChildAdded.call(self, self[key], key);
              added++;
            } // changeChild is handled by the child_changed event
          });

          notifyValueChanged.call(this, this);
          _onValueLoadAnalyzerSuccess.call(this, ss);
        }

        function addChild(ss, listener) {
          var key = ss.key();
          var newValue = ss.val();
          var oldValue = this[ss.key()];

          if (!isUndefined(newValue) && newValue !== null) { // new value
            if (isUndefined(oldValue) || oldValue === null) { // no old value

              this.$$cache.put(key, newValue);

              this[key] = constructChild.call(this, ss, listener);
              this.$$size++;
              notifyChildAdded.call(this, this[key], key);
              notifyValueChanged.call(this, this, this[key], null, key);
            } else {
              changeChild.call(this, ss);
            }
          } else {
            removeChild.call(this, ss);
          }
        }

        function changeChild(ss) {
          var key = ss.key();
          var newValue = ss.val();

          if (!isUndefined(newValue) && newValue !== null) {

            this.$$cache.put(key, newValue);

            var oldValue = this[key];

            if (oldValue && isFunction(oldValue.$update)) {
              oldValue.$update(newValue);
            } else {
              this[key] = constructChild.call(this, ss);
            }

            //if (!equals(this[key], oldValue)) {
            notifyChildChanged.call(this, this[key], oldValue, key);
            notifyValueChanged.call(this, this, this[key], oldValue, key);
            //}
          } else {
            removeChild.call(this, key);
          }
        }

        /**
         *
         * @param {(Object|string)} ss Supports either a key string or a Firebase DataSnapshot.
         */
        function removeChild(ss) {
          var key = ss && isFunction(ss.key) ? ss.key() : ss;
          if (!key) return; // TODO: log a warning or something

          if (!this.$$filteredMode) {
            this.$$cache.remove(key);
          }

          var oldValue = this[key];
          delete this[key];
          this.$$size--;
          notifyChildRemoved.call(this, oldValue, key);
          notifyValueChanged.call(this, this, null, oldValue, key);

          // TODO: this needs to destroy the filtered object only if the rf count is zero. logic may belong in $destroy
          if (!this.$$filteredMode) {
            if (oldValue && isFunction(oldValue.$destroy)) oldValue.$destroy();
          }
        }


        //************************************************************************************************************
        // Data Validation
        //************************************************************************************************************

        function validateFilter(filter) {
          var type;
          if (!filter) throw new Error('%s is not a valid filter!', filter);

          if (isFunction(filter.$on) && isFunction(filter.$off) && isFunction(filter.$addFilter)) {
            type = 'FirebaseObject';
          } else if (isFunction(filter.addListener)) {
            type = 'ObservableArray';
          } else if (isArray(filter)) {
            type = 'array';
          } else {
            throw new Error('%s is unsupported!', filter);
          }

          return {id: hashId++, type: type, filter: filter};
        }


        //************************************************************************************************************
        // Respond to changes to filters
        //************************************************************************************************************

        function filterAdded(newFilter) {
          var filter = newFilter.filter;
          var filterId = newFilter.filter.id;

          //if (this.$$filters.length === 1) {
          // we have changed to filtered mode
          // TODO: reset object and build filtered mode
          // TODO: use a flag to indicate current mode so that you can determine if unfiltered mode was ever initialized, or equivalent
          //}

          // initialize usage of the new filter according to its type
          switch (newFilter.type) {
            case 'array':
              for (var i = 0, length = filter.length; i < length; i++) {
                keyAddedToAFilter.call(this, filter[i], i, newFilter);
              }
              break;

            case 'FirebaseObject':
              this.$$externalListeners.push(
                new FirebaseObjectListener(filter, 'value', valueUpdatedFilterCb, this, {
                  id: filterId,
                  start: true
                }),
                new FirebaseObjectListener(filter, 'child_removed', childRemovedFromFilterCb, this, {
                  id: filterId,
                  start: true
                })
              );

              // TODO: when adding filter function support, implement change watcher. Otherwise, the key isn't changing anyway.
              // TODO: filter function must return boolean which indicates whether the value of the key indicates the key is in or out
              //var childChangedInFilterCb = newFilter.filter.$on('child_changed', function (newValue, oldValue, key) {
              // proc filter method
              //  keyRemovedFromAFilter.call(this, oldValue, key, newFilter);
              //  keyAddedToAFilter.call(this, newValue, key, newFilter);
              //}, this);
              break;

            case 'ObservableArray':
              this.$$externalListeners.push(
                new ObservableArrayListener(filter, 'element_added', childAddedToFilterCb, this, {
                  id: filterId,
                  start: true
                }),
                new ObservableArrayListener(filter, 'element_updated', childChangedInFilterCb, this, {
                  id: filterId,
                  start: true
                }),
                new ObservableArrayListener(filter, 'element_removed', childRemovedFromFilterCb, this, {
                  id: filterId,
                  start: true
                })
              );
              break;
            default:
              console.warn('FirebaseObject.filterAdded called with invalid filter type', newFilter);
          }

          function valueUpdatedFilterCb(updatedFilter) {
            var key;
            var promises = {};
            // optimize initial load vs updates
            if (this.$$size > 0) {
              var changed = false;

              for (key in updatedFilter) {
                if (updatedFilter.hasOwnProperty(key) && !this.hasOwnProperty(key)) {
                  changed = true;
                  keyAddedToAFilter.call(this, updatedFilter[key], key, newFilter);
                }
              }

              if (!changed) {
                notifyValueChanged.call(this, this);
              }
            } else { // this method fully handles initializing and constructing filtered values for the first receipt of a DataSnapshot for performance optimization
              for (key in updatedFilter) {
                if (updatedFilter.hasOwnProperty(key)) {
                  var childRef = this.$$root.child(key);
                  var cachedValue = this.$$cache.get(key);
                  var result = valueFilterInit.call(this, key, childRef);

                  if (cachedValue) {
                    this[key] = constructChild.call(this, new CachedDataSnapshot(key, cachedValue, childRef), result.listener);
                    notifyChildAdded.call(this, this[key], key);
                  } else {
                    promises[key] = result.promise;
                  }
                }
              }

              this.$$size = Object.keys(this).length;

              // call to resolve the $loaded promise.
              if (promises.length > 0) {
                var afterAll = onAll.bind(this);
                $q.all(promises).then(afterAll, afterAll);
              }

              if (this.$$size > 0) {
                notifyValueChanged.call(this, this);
              }
            }
          }

          function onAll() {
            _onValueLoadAnalyzerSuccess.call(this);
          }

          // this method is only called the first time we get a value back from a filter's value listener
          function valueFilterInit(filterKey, childRef) {
            var loadedOnce = false;
            var loadedDeferred = $q.defer();
            var listener = new FirebaseListener(childRef, 'value', childListener, noop, this, {
              id: filterKey,
              start: true,
              bindOnce: this.$bindOnce
            });

            this.$$externalListeners.push(listener);

            return {promise: loadedDeferred.promise, listener: listener};

            function childListener(ss) {
              var key = ss.key();
              var existed = this.hasOwnProperty(key);
              if (!loadedOnce && existed) {
                loadedOnce = true;
                loadedDeferred.resolve();
              }

              if (!loadedOnce) {
                var value = ss.val();

                if (!isUndefined(value) && value !== null) {
                  this.$$cache.put(key, value);
                  this[key] = constructChild.call(this, ss, listener);
                  this.$$size++;
                  notifyChildAdded.call(this, this[key], key);
                  notifyValueChanged.call(this, this, this[key], null, key);
                }

                loadedOnce = true;
                loadedDeferred.resolve();

              } else {
                if (!existed) {
                  addChild.call(this, ss, listener);
                } else if (existed && (isUndefined(ss.val()) || ss.val() === null)) {
                  keyRemovedFromAFilter.call(this, this[ss.key()], ss.key(), newFilter);
                } else {
                  changeChild.call(this, ss);
                }
              }
            }
          }

          function childAddedToFilterCb(newValue, key) {
            keyAddedToAFilter.call(this, newValue, key, newFilter);
          }

          function childChangedInFilterCb(newValue, oldValue, key) {
            keyRemovedFromAFilter.call(this, oldValue, key, newFilter);
            keyAddedToAFilter.call(this, newValue, key, newFilter);
          }

          function childRemovedFromFilterCb(oldValue, key) {
            keyRemovedFromAFilter.call(this, oldValue, key, newFilter);
          }
        }

        function filterChanged(index) {
          filterRemoved.call(this, index);
          filterAdded.call(this, this.$$filters.get(index));
        }

        function filterRemoved(index) {
          destroyFirebaseListenerById.call(this, index);
          var keys = Object.keys(this);
          var i;

          if (this.$$filters.length > 0) {
            // check all current keys to see if they are still in a filter\
            for (i = keys.length; i > -1; i--) {
              if (!filtersContainKey.call(this, keys[i])) {
                removeFilteredKey.call(this, keys[i]);
              }
            }
          } else {
            // if this was the last filter, just remove them all then reinitialize the unfiltered mode listeners
            for (i = keys.length; i > -1; i--) {
              removeFilteredKey.call(this, keys[i]);
            }

            initUnfiltered.call(this);
          }
        }


        //************************************************************************************************************
        // Respond to changes to a filter's values
        //************************************************************************************************************

        /**
         *
         * Check all filters for a specified key, optionally excluding a filter.
         * @param {string} key
         * @param {Object} [filter] A verified filter object. Must have an 'id' property
         * @returns {boolean} true if the key was found, false otherwise.
         */
        function filtersContainKey(key, filter) {
          var value;
          for (var i = 0, outerLength = this.$$filters.length; i < outerLength; i++) {
            if (filter && this.$$filters.get(i).id === filter.id) continue;
            switch (this.$$filters.get(i).type) {
              case 'array':
              case 'ObservableArray':
                for (var j = 0, innerLength = this.$$filters.get(i).filter.length; j < innerLength; j++) {
                  if (this.$$filters.get(i).filter[j] === key) {
                    return true;
                  }
                }
                break;
              case 'FirebaseObject':
                value = this.$$filters.get(i).filter[key];
                if (!isUndefined(value) && value !== null) {
                  return true;
                }
                break;
            }
          }

          return false;
        }

        /**
         * Called by the filtered list manager to update all valid filtered keys on the object.
         * @param {string} filterKey
         * @param {number} [attempts=0]
         */
        function addedFilteredKey(filterKey, attempts) {
          attempts = attempts || 0;
          var childRef = this.$$root.child(filterKey);
          var cachedValue = this.$$cache.get(filterKey);
          var listener = new FirebaseListener(childRef, 'value', childListener, onFilteredKeyFailed, this, {
            id: filterKey,
            start: true,
            bindOnce: this.$bindOnce
          });

          if (isObject(cachedValue)) {
            addChild.call(this, new CachedDataSnapshot(filterKey, cachedValue, childRef), listener);
          }

          this.$$externalListeners.push(listener);

          // call to resolve the $loaded promise.
          if (attempts === 0)
            this.$$loadStatusAnalyzer.isLoaded || this.$$loadStatusAnalyzer.complete();

          function childListener(ss) {
            var key = ss.key();
            var existed = this.hasOwnProperty(key);

            if (!existed) {
              addChild.call(this, ss, listener);
            } else if (existed && (isUndefined(ss.val()) || ss.val() === null)) {
              removeFilteredKey.call(this, ss.key());
            } else {
              changeChild.call(this, ss);
            }
          }

          function onFilteredKeyFailed(e) {
            //console.log("Failed to load " + filterKey + " after " + attempts + " attempts. Retrying in " + Math.min(attempts * 100, 2000) + ". current size=" + this.$$size);
            this.$$cache.remove(filterKey);
            if (this.hasOwnProperty(filterKey))
              removeChild.call(this, filterKey);
            this.$$retryTimeouts[filterKey] = setTimeout(addedFilteredKey.bind(this, filterKey, attempts + 1), Math.min(attempts * 100, 2000));
          }
        }

        function removeFilteredKey(key) {
          destroyFirebaseListenerById.call(this, key);
          removeChild.call(this, key);
          if (this.$$retryTimeouts[key]) {
            clearTimeout(this.$$retryTimeouts[key]);
            delete this.$$retryTimeouts[key];
          }
          //this.$$cache.remove(key); // TODO: need to apply ref-count logic or similar to determine if this can be removed from the cache
        }

        //TODO: remove logging statements
        function keyAddedToAFilter(newValue, key, filter) {
          switch (filter.type) {
            case 'array':
            case 'ObservableArray':
              //if (!filtersContainKey.call(this, newValue, filter)) {
              if (isUndefined(this[newValue]) || this[newValue] === null) {
                addedFilteredKey.call(this, newValue);
              }
              break;
            case 'FirebaseObject':
              //if (!filtersContainKey.call(this, key, filter)) {
              if (isUndefined(this[key]) || this[key] === null) {
                addedFilteredKey.call(this, key);
              } else {
              }
              break;
          }
        }

        function keyRemovedFromAFilter(oldValue, key, filter) {
          switch (filter.type) {
            case 'array':
            case 'ObservableArray':
              if (!filtersContainKey.call(this, oldValue, filter)) {
                removeFilteredKey.call(this, oldValue);
              }
              break;
            case 'FirebaseObject':
              if (!filtersContainKey.call(this, key, filter)) {
                removeFilteredKey.call(this, key);
              }
              break;
          }
        }


        //************************************************************************************************************
        // Misc Utilities
        //************************************************************************************************************

        // TODO: validate constructor and factory if defined. Exactly 0 or 1 may be defined.
        function validatedConstructorArgs(config) {
          //if (isUndefined(config)) {
          //  return;
          //}
          if (isString(config)) {
            if (config) {
              return {path: config};
            } else {
              throw new Error('FirebaseObject: The relative path string cannot be empty!');
            }
          }

          if (config instanceof $window.Firebase) {
            return {ref: config};
          }

          if (!config || !isObject(config)) throw new Error('FirebaseObject: The argument must be a relative path string, a Firebase reference, or a configuration object!');

          if (config.path && config.ref) {
            throw new Error('FirebaseObject: Cannot define both path and ref properties. You must specify exactly one!');
          } else if (config.path && !isString(config.path)) {
            throw new Error('FirebaseObject: The path property must be a string and cannot be empty!');
          } else if (config.ref && !(config.ref instanceof $window.Firebase)) {
            throw new Error('FirebaseObject: The ref property must be a valid Firebase object!');
          } else if (!config.path && !config.ref) {
            throw new Error('FirebaseObject: The config object must contain a relative path in the ".path" property or an existing Firebase reference in the ".ref" property!');
          }

          //config.factory ? config.factory[config.factoryMethodName].bind(config.factory) : null
          var factoryMethodMessage = 'FirebaseObject: The provided factory be an object!';
          if (config.factory) {
            if (!isObject(config.factory) && !isFunction(config.factory)) {
              throw new Error(factoryMethodMessage);
            }
          }

          return config;
        }

        function constructChild(ss, listener) {
          var newObject;

          if (ss.val() == null) {
            return null;
          } else {
            var newValue = ss.val();
            var ref = ss.ref();

            var $ref = function () {
              return ref;
            };

            if (isObject(newValue)) {
              newValue.$id = ss.key();
              if (this.$constructor !== null) {
                newObject = new this.$constructor(newValue, listener);
                newObject.$ref = $ref;
                return newObject;
              } else if (this.$factory.factory !== null) {
                newObject = this.$factory.factory[this.$factory.methodName](newValue, listener);
                newObject.$ref = $ref;
                return newObject;
              } else {
                newValue.$ref = $ref;
                return newValue;
              }
            } else {
              return newValue;
            }
          }
        }

        function __validateEventType(event, methodName) {
          if (!isValidEvent(event)) throw new Error('FirebaseObject.' + methodName + ': called with invalid event type ' + event);
        }

        function isValidEvent(event) {
          return !!FirebaseListener.EVENT_TYPES[event];
        }

        function _onValueLoadAnalyzerSuccess(ss) {
          if (this.$$loadStatusAnalyzer.isLoaded) return;
          this.$$loadStatusAnalyzer.isLoaded = true;
          this.$$loadStatusAnalyzer.deferred.resolve(this);

          //console.log('isLoaded:', this.$$loadStatusAnalyzer.deferred.promise.isFulfilled());

          // validate the cache
          if (!this.$$filteredMode && ss) {
            _updateCache.call(this, ss);
          }
        }

        function _updateCache(ss) {
          if (!ss.exists()) {

            //// remove all keys and destroy the object
            //for (var key in this) {
            //  if (this.hasOwnProperty(key)) {
            //    removeChild.call(this, key);
            //  }
            //}
            //
            //this.$destroy();
            this.$$cache.removeAll();

          } else {
            // remove from the cache and the FBO each key that is not in the DataSnapshot
            var serverData = ss.val();

            //console.log('FirebaseObjectFactory Updating cache');
            //console.log(' - Server Data', serverData);
            //console.log(' - Current Data', copy(this));

            for (var key in this) {
              if (this.hasOwnProperty(key) && !serverData.hasOwnProperty(key)) {
                this.$$cache.remove(key);
                removeChild.call(this, key);
              }
            }
          }
        }


        //************************************************************************************************************
        // Angular Scope Binding Class
        //************************************************************************************************************

        function Binding(vm, propertyName, listners) {
          this.vm = vm;
          this.propertyName = propertyName;
          this.$$listeners = listners;
        }

        Binding.prototype.pause = function pause() {
          var i = this.$$listeners.length;
          var listener;

          while (i--) {
            listener = this.$$listeners[i];
            if (listener.isAlive() && listener.isActive()) {
              listener.pause();
            }
          }
        };

        Binding.prototype.resume = function resume() {
          var i = this.$$listeners.length;
          var listener;

          while (i--) {
            listener = this.$$listeners[i];
            if (listener.isAlive() && !listener.isActive()) {
              listener.resume();
            }
          }
        };

        Binding.prototype.destroy = function destroy() {
          delete this.vm[this.propertyName];
          var i = this.$$listeners.length;
          var listener;

          while (i--) {
            listener = this.$$listeners.pop();
            if (listener.isAlive()) {
              listener.destroy();
            }
          }
        };

        return FirebaseObject;
      }]
  };
}


// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/FirebaseObjectFactory.js